import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-panels',
    templateUrl: './panels.component.html',
    styleUrls: ['./panels.component.scss'],
    standalone: false
})
export class PanelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
